import React from 'react'
import { FavoriteIcon } from './icons'
import { useResources } from './ResourcesProvider'
import { useTranslation } from '../../hooks/useTranslation'
import ResourceCardList from './ResourceCardList'

export const AudioCards = () => {
  return <ResourceCardList Comp={AudioCard} contextPropertyName="audioFiles" />
}

const AudioCard = ({ resource }) => {
  const {
    headerImageUrl,
    headerImageAlt,
    url,
    title,
    description,
    slug,
    completed,
  } = resource
  const { checkResourceFavorite, toggleResourceFavorite, moduleName } =
    useResources()
  const isResourceFavorite = checkResourceFavorite(resource)
  const { t } = useTranslation('index')

  const favoriteIconClass = isResourceFavorite
    ? 'fill-primary stroke-primary'
    : 'stroke-primary'
  const favoriteTitle = isResourceFavorite
    ? t('bookmarked')
    : t('bookmark_this_resource')

  const handleAudioPlay = () => {
    let achievementModule = moduleName
    if (moduleName === 'resumes') {
      achievementModule = 'resume'
    } else if (moduleName === 'job_search') {
      achievementModule = 'job-search'
    } else if (moduleName === 'orientations') {
      achievementModule = 'orientation'
    } else if (moduleName === 'interviews') {
      achievementModule = 'interview'
    }
    const formattedSlug = slug.replace(/-/g, '_')
    fetch(
      `/${achievementModule}/resources/audio/${formattedSlug}/send_achievement`,
      {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
            ?.content,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ achievement_module: achievementModule }),
      },
    )
  }

  return (
    <div className="relative mb-8 overflow-hidden rounded-3xl border border-solid border-[#B9B9B9]">
      <div className="absolute right-4 top-4">
        <button
          className="rounded-lg bg-white p-2 hover:bg-gray-100"
          title={favoriteTitle}
          onClick={() => toggleResourceFavorite(resource)}
        >
          <FavoriteIcon
            className={favoriteIconClass}
            title={favoriteTitle}
            height={24}
          />
        </button>
      </div>
      <img
        src={headerImageUrl}
        alt={headerImageAlt}
        className="aspect-[22/11] w-full object-cover object-center"
      />
      <div className="flex flex-col p-4 md:justify-between">
        <div className="h-28">
          <p className="!my-0 line-clamp-4 flex-grow overflow-hidden  md:leading-relaxed">
            <span
              role="heading"
              tabIndex="0"
              aria-level="2"
              className="!mb-2 !mt-0 break-normal font-roboto text-lg font-semibold focus:overflow-visible"
              title={title}
            >
              {title}
            </span>
            <br />
            {description}
          </p>
        </div>
        <div className="flex justify-between gap-6">
          <audio
            className="w-full"
            controls
            src={url}
            onPlay={() => {
              if (!completed) handleAudioPlay()
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default AudioCard
